import * as Actions from '../../../Modules/CmsActions'
import type { IPagination, Lead, LeadAction } from '../../../Types'

type queryArray = {
  s: any
  doc_id: string
  start_date: Date | null
  end_date: Date | null
  event_id?: string
  orderBy?: string
  order?: string
}
export interface ILead {
  pagination: IPagination | null
  leadInfo: Lead | null
  actions: LeadAction[]
  loading: boolean
  leadActionLoading: boolean
  loadingAction: boolean
  nextLeadActionPage: number | null
  downloading: boolean
  conditions: {
    s: any
    doc_id: string
    start_date: Date | null
    end_date: Date | null
    event_id?: string
    orderBy?: string
    order?: string
  }
  admins: any[]
  submitting: boolean
  filteringQuery: any[]
}

const queryGet = () => {
  const search = window.location.search.slice(1)
  const queryArray: queryArray = {
    s: '',
    doc_id: '',
    start_date: null,
    end_date: null,
    event_id: undefined,
    orderBy: '',
    order: '',
  }
  search.split('&').forEach((search) => {
    const queryArr = search.split('=')
    queryArray[queryArr[0]] = queryArr[1]
  })
  return queryArray
}

const initialState: ILead = {
  pagination: null,
  leadInfo: null,
  loading: true,
  leadActionLoading: false,
  loadingAction: true,
  actions: [],
  nextLeadActionPage: null,
  downloading: false,
  conditions: window.location.search
    ? queryGet()
    : {
        start_date: null,
        end_date: null,
        s: '',
        doc_id: '',
        event_id: undefined,
        orderBy: '',
        order: '',
      },
  admins: [],
  submitting: false,
  filteringQuery: [],
}

const UILeadReducer = (state = initialState, action) => {
  const { type, payload, error } = action

  switch (type) {
    case Actions.REQUEST_SEARCH_LEAD:
    case Actions.REQUEST_FIND_LEAD:
      return {
        ...state,
        loading: true,
        loadingAction: true,
      }

    case Actions.REQUEST_CHANGE_CONDITION_LEAD:
      return updateCondition(state, action.payload.value)

    case Actions.FINISH_SEARCH_LEAD:
      return {
        ...state,
        loading: false,
        list: payload.users,
        pagination: payload.pagination,
        filteringQuery: payload.filteringQuery,
      }

    case Actions.FINISH_FIND_LEAD:
      return { ...state, loading: false, leadInfo: payload.lead }

    case Actions.REQUEST_SEARCH_LEAD_ACTION:
      return { ...state, loadingAction: true, leadActionLoading: true }

    case Actions.FINISH_SEARCH_LEAD_ACTION:
      return error
        ? {
            ...state,
            leadActionLoading: false,
            loadingAction: false,
          }
        : {
            ...state,
            leadActionLoading: false,
            loadingAction: false,
            actions: [...state.actions, ...payload.actions],
            nextLeadActionPage: payload.nextPage,
          }

    case Actions.UNLOAD_LEAD:
      return { ...state, actions: [], nextLeadActionPage: null, leadInfo: null }

    case Actions.REQUEST_CSV_DOWNLOAD_LEAD:
      return { ...state, downloading: true }

    case Actions.FINISH_CSV_DOWNLOAD_LEAD:
      return { ...state, loading: false, downloading: false }

    case Actions.REQUEST_ARCHIVE_LEAD:
      return { ...state, loadingAction: true, leadActionLoading: true }

    case Actions.FINISH_ARCHIVE_LEAD:
      return { ...state, loadingAction: false, leadActionLoading: false }

    case Actions.FINISH_FETCH_ADMINS:
      return { ...state, admins: payload.admins }
    case Actions.FINISH_FIND_LEAD_ACTION:
      return updateLeadAction(state, payload.leadAction)
    case Actions.FINISH_ADD_LEAD_ACTION:
      return addLeadAction(state, payload.leadAction)

    case Actions.FINISH_UPDATE_LEAD_ACTION:
      return updateLeadAction(state, payload.leadAction)

    case Actions.FINISH_DELETE_LEAD_ACTION:
      return deleteLeadAction(state, payload.leadActionId)

    case Actions.REQUEST_UPDATE_LEAD:
      return { ...state, submitting: true }
    case Actions.FINISH_UPDATE_LEAD:
      return { ...state, submitting: false }

    case Actions.FINISH_ADD_COMMENT:
      return addComment(state, payload.comment)

    case Actions.REQUEST_DELETE_COMMENT:
      return { ...state, submitting: true }
    case Actions.FAILED_DELETE_COMMENT:
      return { ...state, submitting: false }
    case Actions.FINISH_DELETE_COMMENT:
      return deleteComment(state, payload.commentId)

    case Actions.FINISH_UPDATE_COMMENT:
      return updateComment(state, payload.comment)

    case Actions.REQUEST_IMPORT_LEAD:
      return { ...state, submitting: true }

    case Actions.FINISH_IMPORT_LEAD:
      return {
        ...state,
        submitting: false,
        filteringQuery: payload.filteringQuery,
      }

    case Actions.REQUEST_CSV_HISTORY:
      return { ...state, submitting: true }
    case Actions.FINISH_CSV_HISTORY:
      return { ...state, submitting: false, csvHistories: payload.csvHistories }

    case Actions.FINISH_LEAD_ACTION_SUMMARY_DOCUMENT:
      return { ...state, documentSummary: payload.documentSummary }

    case Actions.FINISH_LEAD_LOAD:
      return { ...state, loading: false }

    default:
      return state
  }
}

const updateCondition = (state, value) => {
  return {
    ...state,
    conditions: value,
  }
}

const updateLeadAction = (state, leadAction) => {
  return {
    ...state,
    actions: state.actions.map((action) =>
      action.id === leadAction.id ? leadAction : action,
    ),
  }
}

const deleteLeadAction = (state, leadActionId) => {
  return {
    ...state,
    actions: state.actions.filter((action) => action.id !== leadActionId),
  }
}

const addLeadAction = (state, leadAction) => {
  // sort by created_at
  const actions = [leadAction, ...state.actions].sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  })
  return {
    ...state,
    actions,
  }
}

const addComment = (state, comment) => {
  return {
    ...state,
    actions: state.actions.map((action) => {
      if (action.id === comment.lead_action_id) {
        if (action.comments === null) {
          return {
            ...action,
            comments: [comment],
          }
        } else {
          return {
            ...action,
            comments: [...action.comments, comment],
          }
        }
      }
      return action
    }),
  }
}

const deleteComment = (state, commentId) => {
  return {
    ...state,
    actions: state.actions.map((action) => {
      return {
        ...action,
        comments:
          action.comments !== null
            ? action.comments.filter((comment) => comment.id !== commentId)
            : null,
      }
    }),
    submitting: false,
  }
}

const updateComment = (state, comment) => {
  return {
    ...state,
    actions: state.actions.map((action) => {
      if (action.id === comment.lead_action_id) {
        return {
          ...action,
          comments: action.comments.map((c) =>
            c.id === comment.id ? comment : c,
          ),
        }
      }
      return action
    }),
  }
}

export default UILeadReducer
